import { Button, DefaultComponentProps, Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography } from '@albo-ui/core';
import { UpdateFeaturesProps } from '../../customwidgets/customer-features/types';
import { useFeatureUpdate } from './hooks/useFeatureUpdate';
import { MenuItem, Select } from "@mui/material";
import { Close } from "@mui/icons-material";

export const FeatureAdmin = ({ changeAlert, onConfirm, onClose, open, title, listCustomers, featureList }: UpdateFeaturesProps & DefaultComponentProps) => {
    const { form, list, isValidForm, onSelectFeature, onDelete } = useFeatureUpdate(open, listCustomers, changeAlert)

    return (
        <Dialog onClose={onClose} open={open} style={{minWidth: "600px"}}>
            <DialogTitle>
                <Typography variant="h2">{title}</Typography>
            </DialogTitle>
            <DialogContent style={{paddingTop: 30}}>
                <FlexGrid item fullWidth style={{paddingBottom: 20}}>
                    <Select MenuProps={{style: {zIndex: 35001}}}
                        value={form.feature_uuid || '-1'} onChange={onSelectFeature.bind(this)} size="small" fullWidth color="secondary">
                            <MenuItem value={'-1'} disabled>Feature</MenuItem>
                            {featureList?.map((item, index) => (
                                <MenuItem key={`feature-option-${index}`} value={item["uuid"]}>{item["feature_name"]}</MenuItem>
                            ))}
                    </Select>
                </FlexGrid>
                <FlexGrid direction="column" container spacing={1} style={{overflowY: list.length > 5 ? "scroll" : "hidden", maxHeight: "18rem" }}>
                { list.length > 0 && list.map((item, index) => {
                    return (
                        <FlexGrid container item fullWidth alignItems="center" spacing={2} key={index} style={{marginBottom: "10px"}}> 
                            <FlexGrid item style={{width: "4%"}}>
                                <Close titleAccess={`Eliminar de \nla lista`} onClick={() => onDelete(item.customer.uuid)} cursor={"pointer"} fontSize="small"/>
                            </FlexGrid>                 
                            <FlexGrid item style={{fontSize: "18px !important", width: "40%"}}>
                                {item.customer.name}
                            </FlexGrid>
                            <FlexGrid item style={{fontSize: "18px !important", width: "60%"}}>
                                {item.customer.uuid}
                            </FlexGrid>
                        </FlexGrid>
                    )
                })}
                </FlexGrid>
            </DialogContent>
            <DialogActions>
                <FlexGrid fullHeight fullWidth justify='space-between' alignItems='space-between' style={{ marginTop: '20px', display: "flex" }}>
                    <FlexGrid item>
                        <Button onClick={onClose} buttonType='secondary' size='normal'>
                            Cancelar
                        </Button>
                    </FlexGrid>
                    <FlexGrid item style={{textAlign: "end"}}>
                        <Button onClick={() => onConfirm(form)} disabled={isValidForm} size='normal'>
                            Aceptar
                        </Button>
                    </FlexGrid>
                </FlexGrid>
            </DialogActions>
        </Dialog>
    )
}